//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React, {Component} from 'react'
import Reflux from 'reflux'
import Store from '../../../store/store'
import i18 from '../../../i18'
import api from '../../../source/api'
import NotificationSystem from 'react-notification-system'
import RowProcessed from "./assignment/RowProcessed";
import RowUnprocessed from "./assignment/RowUnprocessed";

class Assignment extends Reflux.Component {

    constructor(props) {
        super(props);
        this._notificationSystem = null;
        this.state = {
            showProcessedItems: false,
            processedCount: 0,
            company_id: props.location.match.params.id,
            company: props.company,
            vatCollectorCodes: props.vatCollectorCodes,
            invoices: props.invoices,
            supplierRules: props.supplierRules
        };
        this.store = Store;
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        window.scrollTo(0, 0);
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            invoices: nextProps.invoices,
            supplierRules: nextProps.supplierRules,
            vatCollectorCodes: nextProps.vatCollectorCodes,
            company: nextProps.company,
        });
    }

    _addNotification = (msg, type, time = 30) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        });
    }

    startProcessing = () => {
        this.props.nextStep();
    }

    createRule = (event, ruleData) => {
        api.post({url: 'supplier/rule/add?company_id=' + this.state.company_id, data: ruleData}, true).then((response) => {

            let supplierRules = response.data.supplierRules;
            let invoices = this.state.invoices;
            let rulesCount = this.props.updateInvoices(invoices, supplierRules);

            this._addNotification('Szabály sikeresen mentve.', 'success', 10);
            if (rulesCount.addRuleCount) {
                this._addNotification(rulesCount.addRuleCount + ' db. sor sikeresen kontírozva.', 'success', 10);
            }

            this.props.setData({
                supplierRules: supplierRules,
                invoices: invoices,
            });
        }).catch((err) => {
            document.body.classList.remove('loading-body')
            this.setState({processing: false})
            this._addNotification(err.response.data.error.message, 'error')
        })
    }

    deleteInvoiceItem = (keyIndex) => {
        let indexes = keyIndex.split("-");
        let invoices = this.state.invoices;

        delete invoices[indexes[0]].items[indexes[1]];
        invoices[indexes[0]].items = invoices[indexes[0]].items.filter(Boolean);

        if (invoices[indexes[0]].items.length === 0) {
            delete invoices[indexes[0]];
            invoices = invoices.filter(Boolean);
        }

        this.props.setData({
            supplierRules: this.state.supplierRules,
            invoices: invoices,
        });
    }

    deleteInvoice = (invoiceIndex) => {
        let invoices = this.state.invoices;
        delete invoices[invoiceIndex];
        invoices = invoices.filter(Boolean);
        this.props.setData({
            supplierRules: this.state.supplierRules,
            invoices: invoices,
        });
    }

    removeAllInvoices = () => {
        let invoices = this.state.invoices;

        for (let invoiceIndex in invoices) {
            for (let itemIndex in invoices[invoiceIndex].items) {
                if (!invoices[invoiceIndex].items[itemIndex].main_bookkeeping_number) {
                    delete invoices[invoiceIndex].items[itemIndex];
                }
            }

            invoices[invoiceIndex].items = invoices[invoiceIndex].items.filter(Boolean);
        }

        for (let invoiceIndex in invoices) {
            if (invoices[invoiceIndex].items.length === 0) {
                delete invoices[invoiceIndex];
            }
        }

        invoices = invoices.filter(Boolean);

        this.props.setData({
            invoices: invoices,
        });
    }

    listInvoices = () => {
        let invoices = [];
        let self = this;

        this.state.invoices.map(function (invoice, invoiceIndex) {
            invoice.items.map(function (invoiceItem, invoiceItemIndex) {
                if (invoiceItem.main_bookkeeping_number) {
                    return;
                }
                let id = invoiceIndex + '-' + invoiceItemIndex + '-' + Math.random(9999, 99999);
                invoices.push(
                    <RowUnprocessed
                        key={id}
                        invoice={invoice}
                        invoiceItem={invoiceItem}
                        invoiceIndex={invoiceIndex}
                        keyIndex={id}
                        vatCollectorCodes={self.state.vatCollectorCodes}

                        _addNotification={(msg, type, time) => self._addNotification(msg, type, time)}
                        onCreateRule={(event, ruleData) => self.createRule(event, ruleData)}
                        deleteInvoiceItem={(keyIndex) => self.deleteInvoiceItem(keyIndex)}
                        deleteInvoice={(invoiceIndex) => self.deleteInvoice(invoiceIndex)}
                    />
                );
            });
        });
        return invoices;
    }

    listProcessedInvoices = () => {
        let invoices = [];
        let self = this;
        this.state.invoices.map(function (invoice, invoiceIndex) {
            invoice.items.map(function (invoiceItem, invoiceItemIndex) {
                if (!invoiceItem.main_bookkeeping_number) {
                    return;
                }
                let id = invoiceIndex + '-' + invoiceItemIndex + '-' + Math.random(9999, 99999);
                invoices.push(
                    <RowProcessed
                        key={id}
                        invoice={invoice}
                        invoiceItem={invoiceItem}
                        keyIndex={invoiceIndex + '-' + invoiceItemIndex}
                        invoiceIndex={invoiceIndex}
                        itemIndex={invoiceItemIndex}
                        company={self.state.company}

                        _addNotification={(msg, type, time) => self._addNotification(msg, type, time)}
                        onSetBookKeepingNumber={(invoiceIndex, itemIndex, main_bookkeeping_number) => self.onSetBookKeepingNumber(invoiceIndex, itemIndex, main_bookkeeping_number)}
                        deleteInvoiceItem={(keyIndex) => self.deleteInvoiceItem(keyIndex)}
                        deleteInvoice={(invoiceIndex) => self.deleteInvoice(invoiceIndex)}
                    />
                );
            });
        });
        return invoices;
    }

    onSetBookKeepingNumber = (invoiceIndex, itemIndex, main_bookkeeping_number) => {
        let invoices = this.state.invoices;
        this.state.invoices[invoiceIndex].items[itemIndex].main_bookkeeping_number_custom = main_bookkeeping_number;
        this.setState({invoices: invoices});
    }

    showHideProcessedItems = () => {
        this.setState({showProcessedItems: !this.state.showProcessedItems});
    }

    hasUnprocessedInvoices = () => {
        let unprocessed = false;
        this.state.invoices.map(function (invoice) {
            invoice.items.map(function (invoiceItem) {
                if (!invoiceItem.main_bookkeeping_number) {
                    unprocessed = true;
                }
            });
        });
        return unprocessed;
    }

    render() {

        if (!this.state.invoices) {
            return (
                <div className='col-lg-12 text-center margin-top-50'>
                    <p>Nincs feldolgozandó számla a lekérésben!</p>
                </div>
            );
        }

        return (
            <section id='supplier-assignment'>
                <div className='container-fluid'>

                    <div className='row'>
                        <div className='col-md-6 offset-md-6'>
                            <ul className='legend'>
                                <li><i className='fa fa-dot-circle-o' aria-hidden='true'></i> <span className=''>{i18.SUPPLIER._createRulesAndProcess}</span></li>
                                <li><i className='padding-left-20 fa fa-check-circle' aria-hidden='true'></i> <span className=''>{i18.SUPPLIER._oneTimeProcessing}</span></li>
                            </ul>
                        </div>
                    </div>

                    {this.hasUnprocessedInvoices()
                        ? <table className='table table-striped  table-aibook-no-border'>
                            <thead>
                            <tr>
                                <th>Szállító neve</th>
                                <th>Bizonylatszám</th>
                                <th>Tétel megnevezés</th>
                                <th>Főkönyv szám</th>
                                <th>ÁFA százalék</th>
                                <th>ÁFA gyüjtő kód</th>
                                <th>ÁFA fők. szám</th>
                                <th style={{width: '130px'}}/>
                            </tr>
                            </thead>
                            <tbody>
                            {this.listInvoices()}
                            </tbody>
                        </table>
                        : <div className='text-center margin-top-50 margin-bottom-50'>
                            <p>Minden számlához sikerült szabályt rendelni.</p>
                            <a onClick={() => this.startProcessing()} className='next-step'>{i18.BUTTONS._goToDownload}</a>
                        </div>
                    }

                    <div className='next-step-btn-container margin-top-50 margin-bottom-50 text-left'>
                        <a onClick={() => this.showHideProcessedItems()} className='next-step'>{this.state.showProcessedItems ? i18.BUTTONS._hideProcessedItems : i18.BUTTONS._showProcessedItems}</a>

                        {this.hasUnprocessedInvoices()
                            ? <a onClick={() => this.removeAllInvoices()} className='pull-right table-gray-btn'>Maradék tétel kihagyása</a>
                            : null}
                    </div>

                    {this.state.showProcessedItems
                        ? <table className='table table-striped  table-aibook-no-border'>
                            <thead>
                            <tr>
                                <th>Szállító neve</th>
                                <th>Bizonylatszám</th>
                                <th>Tétel megnevezés</th>
                                <th>Főkönyv szám</th>
                                <th>ÁFA százalék</th>
                                <th>ÁFA gyüjtő kód</th>
                                <th>ÁFA fők. szám</th>
                                <th/>
                            </tr>
                            </thead>
                            <tbody>
                            {this.listProcessedInvoices()}
                            </tbody>
                        </table>
                        : null
                    }
                    <NotificationSystem ref='notificationSystem'/>
                </div>
            </section>
        );
    };
}

export default Assignment


// WEBPACK FOOTER //
// ./src/components/supplier/steps/assignment.js